(ns manatee.user.app-db
  "App. DB for logged in user.")

(def root-path
  [:user])

(def user-id-path
  (conj root-path :id))

(def user-role-path
  (conj root-path :role))

(def user-landing-page-path
  (conj root-path :landing-page))

(def user-features-path
  (conj root-path :features))

(def status-path
  (conj root-path :login-status))

(defn get-user
  [db]
  (get-in db root-path))

(defn set-user
  [db user]
  (assoc-in db
            root-path
            (update-in user [:features] #(mapv keyword %))))

(defn remove-user [db]
  (dissoc db :user))

(defn get-user-id
  [db]
  (get-in db user-id-path))

(defn get-user-role
  [db]
  (get-in db user-role-path))

(defn get-user-landing-page
  [db]
  (get-in db user-landing-page-path))

(defn get-features
  [db]
  (get-in db user-features-path))

(defn get-status
  [db]
  (get-in db status-path))

(defn set-status
  [db status]
  (assoc-in db status-path status))

(defn logging-in?
  [db]
  (#{:logging-in :loading-user} (get-status db)))

(defn admin?
  [db]
  (= "admin" (get-in db user-role-path)))

(defn project-owner?
  [db]
  (= "project-owner"
     (get-user-role db)))

(defn senior-annotator?
  [db]
  (= "senior-annotator"
     (get-user-role db)))

(defn logged-in?
  [db]
  (= :success (get-status db)))

(defn evaluator?
  [db]
  (:is-evaluator (get-user db)))
